export default __webpack_public_path__ + "static/media/cloud-off.24265dbf.svg";